import type { StaffRewardItem } from "../../types";

const BRAND = "#FF6B35";

interface Props {
  item: StaffRewardItem;
}

export function RewardItem({ item }: Props) {
  return (
    <div className="bg-white rounded-2xl p-4 space-y-3">
      {/* 名称 + 金额 */}
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold text-gray-900">{item.item_name}</span>
        <div className="flex items-center gap-1 font-bold text-base" style={{ color: BRAND }}>
          + ¥{item.pay_price}
        </div>
      </div>

      {/* 订单号 */}
      <p className="text-xs text-gray-500">订单号: {item.ordersn}</p>

      {/* 服务时间 */}
      <p className="text-xs text-gray-400">服务时间: {item.book_time_desc}</p>
    </div>
  );
}
